/**
 * Nested-IA alias route — round 4 / #228.
 *
 * Mounts the function creation flow at `/connections/functions/new`
 * so the Codex full-baseline IA inventory resolves. The flat route at
 * `/connections/new-function` continues to work; both render the same
 * `NewFunctionPage` (Argus Tool Developer).
 *
 * Mirrors the original route's `?edit=<id>` search param so deep-links
 * like `/connections/functions/new?edit=<uuid>` work on the alias too.
 */

import { createFileRoute } from '@tanstack/react-router';
import { NewFunctionPage } from './new-function';

export const Route = createFileRoute('/connections/functions/new')({
  validateSearch: (search: Record<string, unknown>) => ({
    edit: (search.edit as string) || '',
  }),
  component: NewFunctionAliasRoute,
});

function NewFunctionAliasRoute() {
  const { edit } = Route.useSearch();
  return <NewFunctionPage editId={edit || undefined} />;
}
